const actions = {
  setToken({ commit }, payload) {
    commit("setToken", payload);
  },
  setShowLogin({ commit }, payload) {
    commit("setShowLogin", payload);
  },
  setAuth({ commit }, payload) {
    commit("setAuth", payload);
  },
  setUserEmail({ commit }, payload) {
    commit("setUserEmail", payload);
  },
  setIsAdmin({ commit }, payload) {
    commit("setIsAdmin", payload);
  },
  setIsInternal({ commit }, payload) {
    commit("setIsInternal", payload);
  },
  setHasSignedAgreements({ commit }, payload) {
    commit("setHasSignedAgreements", payload);
  },
  setStoreVar({ commit }, payload) {
    try {
      commit("setStoreVar", payload);
    } catch (err) {
      console.trace(err);
    }
  },
  setStylingData({ commit }, payload) {
    commit("setStylingData", payload);
  },
  setPageData({ commit }, payload) {
    commit("setPageData", payload);
  },
  setClientID({ commit }, payload) {
    commit("setClientID", payload);
    return payload;
  },
  setTouchScreen({ commit }, payload) {
    commit("setTouchScreen", payload);
    return payload;
  },
  setAccessible({ commit }, payload) {
    commit("setAccessible", payload);
    return payload;
  },
  setNoTouch({ commit }, payload) {
    commit("setNoTouch", payload);
    return payload;
  },
  setAppInitialized({ commit }, payload) {
    commit("setAppInitialized", payload);
    return payload;
  },
  setCategoriesURLQueries({ commit }, payload) {
    commit("setCategoriesURLQueries", payload);
    return payload;
  },
  setStyleID({ commit }, payload) {
    commit("setStyleID", payload);
    return payload;
  },
  setIsSaving({ commit }, payload) {
    commit("setIsSaving", payload);
    return payload;
  },
  setSiteNavigatorVar({ commit }, payload) {
    commit("setSiteNavigatorVar", payload);
  },
  setSettingsVar({ commit }, payload) {
    commit("setSettingsVar", payload);
  },
  setIsMobileDrawerOpen({ commit }, payload) {
    commit("setIsMobileDrawerOpen", payload);
  },
  setDefaultSiteId({ commit }, defaultSiteId) {
    commit("setDefaultSiteId", defaultSiteId);
  },
  setSelectedHomeButton({ commit }, payload) {
    commit("setSelectedHomeButton", payload);
  },
  setServerErrorMessage({ commit }, payload) {
    commit("setServerErrorMessage", payload);
  },
  setSiteBuilderFormVar({ commit }, payload) {
    commit("setSiteBuilderFormVar", payload);
  },
  setIsSiteBuilderFormOpen({ commit }, payload) {
    commit("setIsSiteBuilderFormOpen", payload);
  },
  setShowCMS({ commit }, payload) {
    commit("setShowCMS", payload);
  },
  setOrganizationName({ commit }, payload) {
    commit("setOrganizationName", payload);
  },
  setIsActivated({ commit }, payload) {
    commit("setIsActivated", payload);
  },
  setSearchQuery({ commit }, payload) {
    commit("setSearchQuery", payload);
  },
  setSearchResults({ commit }, payload) {
    commit("setSearchResults", payload);
  },
  setCsDetails({ commit }, payload) {
    commit("setCsDetails", payload);
  },
};

export default actions;
